import {
  GAME_TYPE_BUILD_SENTENCE,
  GAME_TYPE_MULTIPLE_CHOICE,
} from "@/lib/admin-types";

export function cloudTermSheetResourceKey(slug: string): string {
  return `/(cheatsheets)/cloud/${slug}`;
}

export type PracticeGameType =
  | typeof GAME_TYPE_BUILD_SENTENCE
  | typeof GAME_TYPE_MULTIPLE_CHOICE;

export function parsePracticeGameType(
  raw: unknown,
): PracticeGameType | undefined {
  if (raw === GAME_TYPE_MULTIPLE_CHOICE || raw === GAME_TYPE_BUILD_SENTENCE) {
    return raw;
  }
  return undefined;
}

export function practiceGameTypeLabel(gameType: PracticeGameType): string {
  return gameType === GAME_TYPE_MULTIPLE_CHOICE
    ? "Multiple Choice"
    : "Build the Sentence";
}

export function termSheetPracticeSearch(params: {
  resourceKey: string;
  title: string;
  kind: "static" | "cloud";
  sheetId?: number;
  gameType?: PracticeGameType | null;
}) {
  return {
    resource_key: params.resourceKey,
    title: params.title,
    kind: params.kind,
    sheet_id: params.sheetId,
    game_type: params.gameType ?? undefined,
  };
}

export function sentencePuzzlePracticeReturnSearch(params: {
  resourceKey: string;
  title: string;
  kind: "static" | "cloud";
  sheetId?: number;
  gameType: PracticeGameType;
}) {
  return {
    from: "practice" as const,
    ...termSheetPracticeSearch(params),
    game_type: params.gameType,
  };
}
